<template>
    <div>
        <span v-if="float" class="float-label">{{ placeholder }}</span>
        <input
          onclick="this.select()"
          @keydown.up="navigation('up')"
          @keydown.down="navigation('down')"
          @keydown.tab="select(searched[navigate].key || searched[navigate]['.key'], searched[navigate].value)"
          @keyup.enter="select(searched[navigate].key || searched[navigate]['.key'], searched[navigate].value)"
          class="form-control"
          :disabled="disabled"
          :value="value"
          @blur="leave()"
          @focus="focus()"
          @input="searchAndEmit($event.target.value)"
          :type="type"
          :title="error"
          :pattern="pattern"
          :placeholder="placeholder"/>
        <div ref="dropdown" v-if="dropdown" class="card dropdown-list" @mouseover="hovering = true" @mouseleave="hovering = false">
            <a
              v-for="(item, index) in searched"
              :key="index"
              :data-key="item.key || item['.key']"
              :data-value="item.value"
              @mouseenter="navigate = index"
              @click="select( $event.target.getAttribute('data-key'), $event.target.getAttribute('data-value') )"
              class="dropdown-item px-3 py-1"
              :class="{'navigate': navigate === index}">{{item.value}}</a>
        </div>
    </div>
</template>

<script>
  // import _ from 'lodash'
  export default {
    props: {
      type: String,
      placeholder: String,
      pattern: {
        type: String,
        required: false
      },
      value: {
        type: [Number, String],
        required: false
      },
      error: {
        type: String,
        required: false
      },
      originalList: {
        type: Object,
        required: false
      },
      secondList: {
        type: Array,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false
      },
      float: {
        type: Boolean,
        required: false
      }
    },
    data () {
      return {
        searched: [],
        dropdown: false,
        hovering: false,
        key: '',
        navigate: 0
      }
    },
    methods: {
      navigation (direction) {
        if (direction === 'up') {
          if (this.navigate <= 0) return
          --this.navigate
          if (this.navigate >= 9 || this.$refs.dropdown.scrollTop > 0) this.$refs.dropdown.scrollTop = this.$refs.dropdown.scrollTop - 32
        } else {
          if (this.navigate === this.searched.length - 1) return
          ++this.navigate
          if (this.navigate >= 9) this.$refs.dropdown.scrollTop = this.$refs.dropdown.scrollTop + 32
        }
      },
      match: function (regex) {
        regex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        let re = new RegExp(regex, 'i')
        return function (element) {
          return re.test(element)
        }
      },
      search: window._.debounce(function (regex) {
        if (regex !== '') {
          this.searched = []
          this.secondList.forEach((entry) => {
            let newRegex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            let re = new RegExp(newRegex, 'i')
            if (re.test(entry['.value'])) {
              let obj = {}
              obj['.key'] = entry['.key']
              obj.value = entry['.value']
              // console.log(obj)
              this.searched.push(obj)
              // console.log({attr: this.originalList[attr]})
            }
          })
          // this.searched = this.originalList.filter(this.match(value));
          this.dropdown = true
        } else {
          this.searched = []
        }
      }, 200),
      select: function (key, value) {
        this.$emit('input', {key: key, value: value})
        this.dropdown = false
      },
      searchAndEmit: function (value) {
        this.navigate = 0
        this.search(value)
        this.$emit('input', {key: null, value: value})
      },
      leave: function () {
        setTimeout(() => { this.dropdown = false }, 150)
      },
      focus: function () {
        this.navigate = 0
        if (this.value !== '') this.search(this.value)
      }
    }
  }
</script>

<style scoped>
    .dropdown-list {
        position: block;
        z-index: 9001;
        box-shadow: 0px 5px 8px 0 rgba(0,0,0,0.4);
        color: black;
        /*margin-top: -.75rem;*/
        max-height: 300px;
        overflow-y: auto;
    }
 
    a {
        cursor: pointer;
    }

    a:active {
        background-color: #fff;
    }

    .float-label {
      position: absolute;
      padding-left: .75rem;
      top: -1.1rem;
    }

    .navigate {
      background-color: #cbccce;
      color: black !important;
    }
</style>
